import { useRef, useState, useEffect } from "react";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import VariableAction from "../../../actions/VariableAction";
function ChatboxVariable({name, value}) {
    
    const { deleteVariable, updateVariable } = VariableAction();
    const inputSpan = useRef();
    const divName = useRef();
    const [width, setWidth] = useState(0);
    const paddingOffset = 10;
    const sizeOfDiv = 450;

    if(typeof value == 'boolean') {
        value = new Boolean(value).toString()
    }

    if(typeof value == 'number') {
        value = new Number(value).toString()
    }

    useEffect( () => {
        if(inputSpan == null || divName == null) {
            return;
        }

        let tmpWidth = inputSpan.current.offsetWidth + paddingOffset;
        let maxWidth = sizeOfDiv - divName.current.offsetWidth + paddingOffset;
        tmpWidth = tmpWidth > maxWidth ? maxWidth : tmpWidth
        setWidth(tmpWidth)
    }, [inputSpan, divName, value]);

    const onDelete = () => deleteVariable(name)
    
    return (
        <div className="kwalys-variable">
            <div style={ { marginRight : '8px' } } ref={divName}>
                <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" onClick={onDelete}></IconButton>
                <span title={name}>{name}</span>
            </div>
            <div style={ { width : '430px' }}>
                <label className="hidden" ref={inputSpan}>{value}</label>
                {value != '' ? <input autoComplete="off" value={value} onChange={(e) => updateVariable(name, e.target.value)} style={{ width: width ? width + 'px' : 'auto' }}></input> : null }
            </div>
        </div>
    )
}

export default ChatboxVariable;